export default "__VITE_ASSET__DVjzbQaM__"